import { Injectable, NgZone, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Firestore, doc, onSnapshot } from '@angular/fire/firestore';

export interface CallStatusEvent {
  EventType: 'CALL_ANSWERED' | 'RINGING' | 'CALL_FAILED' | 'INVALID_PHONE_NUMBER' | 'HANGUP' | string;
  TransactionId: string;
  ExternalUserId?: string;
  AttendeeId?: string;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root',
})
export class CallStatusService {
  private zone = inject(NgZone);
  private firestore = inject(Firestore);

  private unsubscribe: (() => void) | null = null;
  private callStatusSubject = new BehaviorSubject<CallStatusEvent | null>(null);
  public callStatus$: Observable<CallStatusEvent | null> = this.callStatusSubject.asObservable();

  connect(tenantId: string, callId: string, transactionId: string): void {
    if (this.unsubscribe) {
      this.disconnect();
    }

    console.log(`Subscribing to call status updates in Firestore: workspace-events/${tenantId}/contents/${callId}/pstn/${transactionId}`);
    
    const docRef = doc(this.firestore, 'workspace-events', tenantId, 'contents', callId, 'pstn', transactionId);

    this.unsubscribe = onSnapshot(
      docRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const eventData = snapshot.data() as CallStatusEvent;
          console.log('Received call status event from Firestore:', eventData);
          this.zone.run(() => {
            this.callStatusSubject.next(eventData);
          });
        }
      },
      (error) => {
        console.error('Firestore call status subscription error:', error);
        this.zone.run(() => {
          this.callStatusSubject.next({ EventType: 'CALL_FAILED', TransactionId: transactionId, error: error.message });
        });
        this.disconnect();
      }
    );
  }

  disconnect(): void {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
    this.callStatusSubject.next(null);
  }
}
